LS.form = {
	/**
	 * Resize input to fit content
	 *
	 * @param {$} el
	 * @param {String} [namespace]
	 * @param {Function} [update]
	 */
	resize(el, namespace, update) {
		$(el).each(el => {
			const $el = $(el);

			let current;
			let previous;
			let updated;

			$el.on('input', (e, el) => {
				current = el.scrollHeight;

				el.style.height = updated = 'auto';

				if (el.value) {
					updated = Math.max(current, Math.floor(current + 2));
				}

				el.style.height = updated + 'px';

				if (updated !== previous) {
					previous = updated;

					$.exec(update);
				}
			}, {
				init: true,
				namespace: namespace
			});

			requestAnimationFrame(() => {
				$el.trigger('focus');
			});
		});
	},

	/**
	 * Validate form based on inline and custom rules
	 *
	 * @param {$} el
	 * @param {Object} [data]
	 * @param {Boolean|Object} [rules]
	 * @param {Object} [options]
	 * @returns {Boolean}
	 */
	validate(el, data, rules, options) {
		const $form = $(el);
		const conf = Object.assign({
			labels: []
		}, options);
		const context = conf.context || $form;
		const $inputs = $(':invalid:not(fieldset)', context);
		const attributes = [
			'data-case',
			'max',
			'maxlength',
			'min',
			'minlength',
			'pattern',
			'required'
		];

		data = data || $form.serialize(true, false);

		rules = $.isObject(rules) ?
			rules : {};

		$inputs.add($('input[type="email"], input[type="tel"], input[type="url"], input[required], textarea[required], [data-case]', context))
			.filter((index, el) => ! el.disabled && ! $.closest(el, '.-is-disabled', $form).length)
			.each(el => {
				const name = el.name || el.id;

				if (! name) {
					return;
				}

				const type = el.getAttribute('type');
				const values = [];

				let label = el.dataset.label;

				attributes.forEach(attribute => {
					const attr = el.getAttribute(attribute);

					if (attr !== null) {
						values.push(attribute + (
							attr ? ':' + attr : ''
						));
					}
				});

				if (
					type === 'email' ||
					type === 'numeric' ||
					type === 'tel' ||
					type === 'url'
				) {
					values.push(type);
				}

				if (values.length) {
					rules[name] = rules[name] ? [
						...rules[name],
						...values
					] : values;
				}

				if (! label) {
					label = el.getAttribute('aria-label');

					if (label) {
						label = label.toLowerCase();
					} else {
						const assoc = $('label[for="' + el.id + '"]')[0];

						if (assoc) {
							label = assoc.firstChild.nodeValue;
						}
					}

					if (label) {
						label = label.charAt(0).toLowerCase() + label.slice(1);
					}
				}

				if (label) {
					conf.labels[name] = label;
				}
			});

		$('input[type="checkbox"]', $form)
			.filter((index, el) => ! el.checked)
			.each(el => {
				if (el.name && el.name.slice(-2) !== '[]') {
					data[el.name] = '0';
				}
			});

		const validator = LS.validate.run(data, rules, conf);

		if (validator === true) {
			return true;
		}

		LS.validate.highlight($('[name="' + validator[0] + '"]', $form), true);

		return false;
	},

	/**
	 * Disable default submission
	 *
	 * @param {$} el
	 * @param {String} namespace
	 */
	restrict(el, namespace) {
		const $form = $(el);

		$form.on('submit', () => {
			//
		}, {
			cancel: true,
			namespace: namespace
		});

		$form.on('keydown', e => {
			if (
				e.keyCode === 13 &&
				e.target.tagName !== 'TEXTAREA'
			) {
				e.preventDefault();
			}
		}, {
			namespace: namespace
		});
	}
};

$.chain('resize', function(namespace, update) {
	LS.form.resize(this, namespace, update);

	return this;
});